import { } from "@heroicons/react/20/solid";
import { PlusCircleIcon } from "@heroicons/react/24/outline";
import classNames from "classnames";
import React from "react";
import { useFieldArray, useWatch } from "react-hook-form";
import { ManagePartisanChartState } from '../../hooks/use-manage-partisan-chart';
import Trash from "../../../../../components/icons/trash";

interface ManagePartisanNonPartisanChartCandidateNamesProps {
	index: number;
	managePartisanChartState: ManagePartisanChartState;
}

const ManagePartisanNonPartisanChartCandidateNamesItem: React.FC<
	ManagePartisanNonPartisanChartCandidateNamesProps
> = ({ index, managePartisanChartState }) => {
	const {
		form: { control, register, getValues, setValue },
	} = managePartisanChartState;
	const { fields, append, remove } = useFieldArray({
		control,
		name: `races.${index}.candidateNames`,
	});

	const watchFields = useWatch({
		control: control,
		name: `races.${index}.candidateNames`,
	});

	const getCountNamesAdded = () => {
		let sum = 0;
		const candidateNames =
			getValues().races[index]?.candidateNames ?? [];
		candidateNames.forEach((candidate) => {
			if (candidate.name && candidate.name.length) {
				sum += 1;
			}
		});
		return sum;
	};

	return (
		<>
			<div style={{ marginBottom: "20px" }}>
				<span style={{ marginRight: "10px" }}>
					Candidates
				</span>
				<span>{`(${getCountNamesAdded()}/${getValues().races[index].candidates ?? 0
					})`}</span>
			</div>
			<div className="flex flex-col w-[380px]">
				{fields.map((field, i) => {
					return (
						<div className="flex">
							<input
								key={field.id} // important to include key with field's id
								{...register(
									`races.${index}.candidateNames.${i}.name`
								)}
								type="text"
								placeholder="Full name"
								className={"w-full py-3 mb-2 px-4 bg-[#E6EBF5] rounded-md"}
							/>
							<input
								{...register(
									`races.${index}.candidateNames.${i}.order`
								)}
								type="number"
								value={Number(i)}
								style={{ display: "none" }}
							/>
							<div className="ml-2">
								<button
									className="p-2 mt-2 bg-gray-200 rounded-full"
									onClick={() => {
										remove(i);
										setValue(
											`races.${index}.candidates`,
											getValues().races[index].candidates -
											1
										);
									}}
								>
									<Trash className="w-4 h-4" />
								</button>
							</div>
						</div>
					);
				})}
			</div>
			<button
				onClick={() => {
					append({ name: "", order: fields.length });
					setValue(
						`races.${index}.candidates`,
						getValues().races[index].candidates
							? getValues().races[index].candidates + 1
							: 1
					);
				}}
				type="button"
				className={classNames(
					"w-auto font-semibold py-2 flex justify-start items-center mb-8 text-primary-blue rounded-md"
				)}
			>
				<PlusCircleIcon className="w-6 mr-2" />
				Add Another Candidate
			</button>
		</>
	);
};

export default ManagePartisanNonPartisanChartCandidateNamesItem;
